import React from "react";

type GroupButtonItem = {
  key: string;
  title?: string;
  icon?: React.ComponentType<any>;
  color: string;
  onClick: () => void;
  disabled?: boolean;
  tooltip?: string;
};

type Props = {
  items: GroupButtonItem[];
};

const buildGradient = (color: string) =>
  `linear-gradient(180deg, ${color}, ${color}CC)`;

export const GroupButton = ({ items }: Props) => {
  return (
    <div style={{ display: "inline-flex", gap: 8 }}>
      {items.map((item) => {
        const Icon = item.icon;
        const bg = buildGradient(item.color);

        return (
          <div
            key={item.key}
            style={{
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
            }}
            onMouseEnter={(e) => {
              if (item.disabled) return;
              const tip = e.currentTarget.querySelector(
                "[data-tooltip]"
              ) as HTMLElement;
              if (tip) {
                tip.style.opacity = "1";
                tip.style.transform = "translateX(-4px)";
              }
            }}
            onMouseLeave={(e) => {
              const tip = e.currentTarget.querySelector(
                "[data-tooltip]"
              ) as HTMLElement;
              if (tip) {
                tip.style.opacity = "0";
                tip.style.transform = "translateX(0)";
              }
            }}
          >
            {item.tooltip && (
              <div
                data-tooltip
                style={{
                  position: "absolute",
                  left: "100%",
                  marginRight: 2,
                  padding: "4px 6px",
                  background: "rgba(10, 175, 161, 0.96)",
                  color: "#fff",
                  fontSize: 10,
                  fontWeight: 600,
                  borderRadius: 8,
                  whiteSpace: "nowrap",
                  pointerEvents: "none",
                  opacity: 0,
                  transform: "translateX(0)",
                  transition: "opacity 120ms ease, transform 120ms ease",
                  boxShadow: "0 6px 16px rgba(0,0,0,0.28)",
                  zIndex: 1001,
                }}
              >
                {item.tooltip}
              </div>
            )}

            <button
              onClick={item.onClick}
              disabled={item.disabled}
              style={{
                height: 36,
                minWidth: 44,
                padding: "0 14px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                border: "none",
                borderRadius: 12,
                background: bg,
                color: "#fff",
                fontSize: 13,
                fontWeight: 600,
                cursor: item.disabled ? "not-allowed" : "pointer",
                opacity: item.disabled ? 0.45 : 1,
                transition: "filter 140ms ease, transform 140ms ease",
              }}
              onMouseEnter={(e) => {
                if (item.disabled) return;
                e.currentTarget.style.filter = "brightness(1.12) saturate(1.1)";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.filter = "none";
                e.currentTarget.style.transform = "none";
              }}
            >
              {Icon && <Icon size={18} />}
              {item.title && <span>{item.title}</span>}
            </button>
          </div>
        );
      })}
    </div>
  );
};
